<template>
    <div class="banner">
      <div class="project-banner" :style="{backgroundImage: 'url(' + bannerimg + ')','background-repete':'no-repete','background-size':'cover','background-position':'center','background-color':'#242933'}">
        <div class="container text-center">
          <img src="@/assets/img/pro_name.png" class="pro-img" >
          <p class="bannertext">{{bannertext}}</p>
          <div class="text-center">
              <el-button @click="handleAdd()" class="el-button mr-30 el-button--warning" style="color: #fff;">立即体验</el-button>
              <el-button v-on:click="subtract()">了解更多</el-button>
          </div>
        </div>
      </div>
    <NewsDialog :visible.sync="dialogVisible"/>
    </div>
</template>
<script>
import NewsDialog from '../../news/pages/newsDialog.vue'
export default{
    data() {
        return {
           bannertext: '数智化临床研究解决方案专家，助力新药研发，轻松创建、部署和管理你的临床试验项目，降本增效，加速新药上市！',
           bannerimg: require('../../../assets/img/pro_bannerbg@2x.jpg'),
           dialogVisible: false
        };
    },
    components:{
        NewsDialog
    },
    methods: {
      subtract() {
        this.$router.push({path:'/prolist'})
      },
      handleAdd(){
        this.dialogVisible = true
      },
    
    }
}

</script>
<style scoped>
.project-banner{
  width: 100vw;
  height: 100vh;  
}
.bannertext{
  color:#fff;
  text-shadow: 0 0  3px #000;
  margin-bottom: 50px;
  font-size: 18px;
}
.pro-img{
  width:400px;
  margin-top:200px;
  margin-bottom: 20px;
}
.mr-30{
  margin-right: 30px;
}
.about-text{
  text-indent: 2em;;
}
@media (min-width: 1400px) and (max-width: 1920px) {
    .pro-img {
        margin-top:220px;
        width: 400px;
    }
}
@media (min-width: 1920px) {
    .pro-img {
        width:500px;
        margin-top:240px;
    }
}
@media (min-width: 1200px) and (max-width: 1400px) {
    .pro-img {
        width:300px;
        margin-top:180px;
    }
}
</style>